import React, { useRef } from "react";
import { CSSTransition } from "react-transition-group";

import { easings } from "@apps/viewer/src/ts/config";

/**
 * Specification of the crossfade duration.
 */
const FADE_DURATION = 150;

/**
 * Simple css fade transition that'll fade between preloader and  definition
 * when it's avaialble.
 */
// tslint:disable-next-line variable-name no-reserved-keywords
export const Fade: React.FC<{ in?: boolean; children: React.ReactNode }> = (props) => {
    const ref = useRef<HTMLSpanElement>(null);

    return (
        <CSSTransition
            {...props}
            mountOnEnter
            unmountOnExit
            timeout={ FADE_DURATION }
            classNames="glossaryWord__fade"
            nodeRef={ref}
        >
            <span ref={ref}>
                {props.children}

                <style jsx global>{`
                    /** Apply fade-in */
                    .glossaryWord__fade-enter,
                    .glossaryWord__fade-appear {
                        opacity: 0.001;
                    }

                    .glossaryWord__fade-enter-active,
                    .glossaryWord__fade-appear-active {
                        opacity: 1;
                        transition: opacity ${ FADE_DURATION }ms linear;
                    }

                    /** Apply fade-out */
                    .glossaryWord__fade-exit {
                        opacity: 1;

                        /** Underflow the content that's fading in */
                        position: absolute;
                        bottom: calc(10px - 0.15em);
                        left: 10px;
                        z-index: 0;
                    }

                    .glossaryWord__fade-exit-active {
                        opacity: 0.001;
                        transition: opacity ${ FADE_DURATION }ms linear;
                    }

                    .glossaryWord__fade-exit-done {
                        opacity: 0;
                    }
                `}</style>
            </span>
        </CSSTransition>
    );
};
